import React, { useState } from 'react';
import './App.css';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Home from './pages/Home';
import Navbar from './components/Navbar/Navbar';
import Sidebar from './components/Sidebar/Sidebar';
import WatchlistPage from './pages/WatchlistPage';
import SearchPage from './pages/SearchPage';
import MovieDetail from './pages/MovieDetail';
import ScrollToTop from './components/ScrollToTop';
import FeaturedMoviesPage from './pages/FeaturedMoviesPage';
import NewMoviesPage from './pages/NewMoviesPage';
import Footer from './components/Footer/Footer';

function App() {

  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  }

  
  return (
    <Router>
        <Navbar isOpen={isOpen} toggleSidebar={toggleSidebar} />
        <Sidebar isOpen={isOpen} toggleSidebar={toggleSidebar} />
        <Switch>
          <Route exact path="/" component={Home} />
          <ScrollToTop>
            <Route path="/movie/:movieId" component={MovieDetail} />
            <Route path="/watchlist" component={WatchlistPage}/>
            <Route path='/new-movies' component={NewMoviesPage} />
            <Route path='/trending-movies' component={FeaturedMoviesPage} />
            <Route path="/search" component={SearchPage}/>
          </ScrollToTop>
        </Switch>
        <Footer />
    </Router>
  );
}

export default App;